








































import { computed, defineComponent, ref, watch, getCurrentInstance } from '@vue/composition-api';
import _ from 'lodash';
import { ChevronDownIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';

// 引入 compositions
import meetingHandler from '../meetingHandler';
const MeetingError: any = {
  MEETING_STATE_INVALID: i18n_t('会议号无效'),
  MEETING_STATE_CANCELLED: i18n_t('会议已被取消'),
  MEETING_STATE_ENDED: i18n_t('会议已被删除'),
  MEETING_STATE_RECYCLED: i18n_t('会议号已被回收'),
};
export default defineComponent({
  components: {
    ChevronDownIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { meetingLists, meetingCode, methods: meetingMethods } = meetingHandler();
    const validateTip = ref('');
    const joinDisabled = ref(true);
    const popupVisible = ref(false);
    const validateCode = (code: string) => {
      if (code === '') {
        validateTip.value = i18n_t('会议号不能为空');
        joinDisabled.value = true;
      } else if (code.length > 12) {
        validateTip.value = i18n_t('会议号不能超过12位');
        joinDisabled.value = true;
      } else {
        validateTip.value = '';
        joinDisabled.value = false;
      }
    };
    const throttleValidate = _.throttle(code => {
      meetingCode.value = code.replace(/[^0-9]/g, '');
      validateCode(meetingCode.value as string);
      popupVisible.value = false;
    }, 200);
    const methods = {
      onOptionClick(val: SMH.meetingListInfo) {
        validateCode(val.meeting_code);
        meetingCode.value = val.meeting_code;
        popupVisible.value = false;
      },
      onPopupVisibleChange(val: boolean) {
        if (!meetingLists.value) return;
        popupVisible.value = val;
      },
      async onJoinMeeting() {
        const joinUrl = await meetingMethods.joinMeeting();
        if (joinUrl) {
          innerShow.value = false;
          setTimeout(() => {
            dispatchRouter(joinUrl);
          }, 100);
        }
      },
    };
    watch(innerShow, val => {
      if (val) {
        meetingMethods.getMeetingLists();
        meetingCode.value = '';
        validateTip.value = '';
      }
    });
    return {
      validateCode,
      throttleValidate,
      validateTip,
      innerShow,
      meetingCode,
      joinDisabled,
      meetingLists,
      popupVisible,
      ...methods,
      ...meetingMethods,
    };
  },
});
